export default __webpack_public_path__ + "static/media/trans_withdraw.435fd34b.svg";